<template>
    <div class="row">
        <div class="modal hide fade" id="modalJournalData" tabindex="-1" role="dialog" aria-labelledby="modalJournalData" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header red darken-3 text-left text-white">
                        <h4 class="modal-title w-100 font-weight-bold">
                            Journal - {{ journal.journal_code }}
                            <span class="badge badge-success" v-if="journal.status === 'posted'"> {{ journal.status }}</span>
                            <span class="badge badge-warning" v-else> {{ journal.status }}</span>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row dl-custom">
                                    <dt class="col-md-4">Date</dt>
                                    <dd class="col-md-8">{{ journal.journal_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dt class="col-md-4">Type</dt>
                                    <dd class="col-md-8">{{ journal.type_id }}</dd>

                                    <dt class="col-md-4">Ref No.</dt>
                                    <dd class="col-md-8">{{ journal.ref_no }}</dd>

                                    <dt class="col-md-4">Contact</dt>
                                    <dd class="col-md-8">{{ journal.contact }} - <b>{{ journal.contact_name }}</b></dd>

                                    <dt class="col-md-4">Description</dt>
                                    <dd class="col-md-8">{{ journal.journal_description }}</dd>

                                    <dt class="col-md-4">Company</dt>
                                    <dd class="col-md-8"><b>[{{ journal.company_no }}]</b> {{ journal.company }}</dd>
                                </dl>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-item table-sm table-hover table-striped">
                                        <thead>
                                            <th>Account</th>
                                            <th>Remark</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in journal.details" :key="d.id">
                                                <td><b>[{{ d.account_code }}]</b> {{ d.account_name }}</td>
                                                <td>{{ d.remark }}</td>
                                                <td class="text-right">{{ d.debit | currency }}</td>
                                                <td class="text-right">{{ d.credit | currency }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td class="text-right"><b>{{ journal.debit | currency }}</b></td>
                                                <td class="text-right"><b>{{ journal.credit | currency }}</b></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ journal }}</pre> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'JournalModal',
  computed: {
    ...mapState({
      journal: state => state.journals.journal
    })
  }
}
</script>
